import { AppModule } from "./../app.module";
import { NgModule } from "@angular/core";

import { MenuItems } from "./menu-items/menu-items";
import {
  AccordionAnchorDirective,
  AccordionLinkDirective,
  AccordionDirective,
} from "./accordion";
import { AppHeaderComponent } from "../layouts/full/header/header.component";
import { FullComponent } from "../layouts/full/full.component";
import { AppSidebarComponent } from "../layouts/full/sidebar/sidebar.component";
import { SpinnerComponent } from "./spinner.component";
import { MaterialModule } from "../material-module";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { MoreInfoModalComponent } from "./more-info-modal/more-info-modal.component";
import { FileDetailsComponent } from "./file-details/file-details.component";
import { ImageViewerComponent } from "../image-viewer/image-viewer.component";
import { BrowserModule } from "@angular/platform-browser";
import { AngularImageViewerModule } from "@hreimer/angular-image-viewer";
import { SlickCarouselModule } from "ngx-slick-carousel";
import { ReactiveFormsModule } from "@angular/forms";
import { FileUploadComponent } from "./file-upload/file-upload.component";
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";
import { RemarksModalComponent } from './remarks-modal/remarks-modal.component';
import { ViewPdfModalComponent } from './view-pdf-modal/view-pdf-modal.component';
import { ApplicationTimelineComponent } from './application-timeline/application-timeline.component';
import { LegendsComponentComponent } from './legends-component/legends-component.component';
@NgModule({
  declarations: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    AppHeaderComponent,
    FullComponent,
    SpinnerComponent,
    AppSidebarComponent,
    MoreInfoModalComponent,
    FileDetailsComponent,
    ImageViewerComponent,
    FileUploadComponent,
    RemarksModalComponent,
    ViewPdfModalComponent,
    ApplicationTimelineComponent,
    LegendsComponentComponent,
  ],
  exports: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    AppHeaderComponent,
    FullComponent,
    SpinnerComponent,
    AppSidebarComponent,
    MoreInfoModalComponent,
    FileDetailsComponent,
    FileUploadComponent,
    ApplicationTimelineComponent
  ],
  imports: [
    NgxExtendedPdfViewerModule,
    MaterialModule,
    RouterModule,
    CommonModule,
    SlickCarouselModule,
    ReactiveFormsModule,
  ],
  providers: [MenuItems],
})
export class SharedModule { }
